import { render, staticRenderFns } from "./DefaultForm.vue?vue&type=template&id=0a56a181&scoped=true"
import script from "./DefaultForm.ts?vue&type=script&lang=ts&external"
export * from "./DefaultForm.ts?vue&type=script&lang=ts&external"
import style0 from "./DefaultForm.vue?vue&type=style&index=0&id=0a56a181&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56a181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a56a181')) {
      api.createRecord('0a56a181', component.options)
    } else {
      api.reload('0a56a181', component.options)
    }
    module.hot.accept("./DefaultForm.vue?vue&type=template&id=0a56a181&scoped=true", function () {
      api.rerender('0a56a181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Masters/components/forms/DefaultForm/DefaultForm.vue"
export default component.exports